import styled from 'styled-components'

export const HomeContainer = styled.div`
	padding: 2rem;
	text-align: center;
`
